import { render, staticRenderFns } from "./TicketsetDialog.vue?vue&type=template&id=6e808c86&"
import script from "./TicketsetDialog.vue?vue&type=script&lang=js&"
export * from "./TicketsetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports